import {
    ChangeDetectorRef,
    Component,
    OnInit,
    Inject,
    AfterViewInit,
    ViewChild,
    ElementRef,
    HostListener,
    OnDestroy,
    ChangeDetectionStrategy, Output, EventEmitter
} from '@angular/core';
import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators
} from '@angular/forms';

import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { environment } from '@app/utils/get-api-url';

import { SystemSettingsService } from '@app/services';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {JobViewService} from '@app/features/customers/customer/jobs-view/service/job-view-service';
import {debounceTime, takeUntil} from 'rxjs/operators';

declare var $: any;

interface StockLocationTotal {
    id: number;
    location: string;
    totalQty: number;
}

interface FulfillmentSummary {
    stockLocationTotals: StockLocationTotal[];
    otherSourceTotals: { [sourceId: string]: number };
    fulfilledPartsCount: number;
    notFulfilledPartsCount: number;
    totalPartsCount: number;
}

interface FulfillmentStatus {
    isFulfilled: boolean;
    totalFulfilled: number;
    fromStock: number;
    fromOther: number;
}

@Component({
    selector: 'app-fulfil-parts-modal',
    templateUrl: './fulfil-parts.modal.html',
    styleUrls: ['./fulfil-parts.modal.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
            trigger('slideAnimation', [
                transition(':leave', [
                    animate('1000ms ease-in', style({ height: 0, opacity: 0 })),
                ]),
            ]),
        ]
})
// tslint:disable-next-line:component-class-suffix
export class FulfilPartsModal implements OnInit, AfterViewInit, OnDestroy {

    constructor(
        private formBuilder: FormBuilder,
        @Inject('$scope') private ajsScope,
        private jobViewService: JobViewService,
        public bsModalRef: BsModalRef,
        private changeDetector: ChangeDetectorRef,
        private systemSettingsService: SystemSettingsService,
        @Inject('jobData') private jobData: any,
        @Inject('ajsState') private ajsState,
    ) {}

    get f() {
        return this.form.controls;
    }
    @ViewChild('select2StockLocs') set select2StockLocs(el: ElementRef) {
        if (el) {
            this._select2StockLocs = el;
            // Ensure Select2 is initialized if it's not already
            if (!$(this._select2StockLocs.nativeElement).data('select2')) {
                this.initAndAttachMainSelect2();
            }
            $(this._select2StockLocs.nativeElement).on('change', () => {
                this.updateLocation();
                this.updateLocationViewStatus();
            });
        }
    }

    get partsFormArray() {
        return this.form.get('parts')['controls'];
    }
    public onClose: Subject<any>;
    title = 'Add part kit';
    closeBtnName = 'Cancel';
    select2Config: any = {};
    stockLocationsSelect2Config: any = {};
    selectedRows: any = {};
    jobId: any = '';
    customerId: any = '';
    customerType: any = '';
    selectedEngineerStockLocations: any[] = [];
    selectedPartsId = '';
    moduleId: any= '';
    jobToDos: any= '';

    form: FormGroup;
    action = '';
    isDataReady = false;
    engineerStocklocations: any[] = [];
    massStockSource = '';

    massUpdateDropdownOpen = false;
    fulfilFromStockRooms: { id: number, label: string, selected: boolean }[] = [];
    fulfilFromOthers = [
        { id: 1, label: 'Order remaining from supplier', selected: false },
        { id: 2, label: 'Leave remaining on request', selected: false },
        { id: 3, label: 'Mark as available', selected: false }
    ];

    fulfilFromOtherMapping = {
        1: 'job.purchase.order',
        2: 'job.leave.remaining',
        3: 'job.general'
    };

    @ViewChild('massUpdateContainer') massUpdateContainer!: ElementRef;

    parts = [];
    selectedPartId: any;

    @ViewChild('saveBtn') saveBtn: ElementRef;
    private _select2StockLocs: ElementRef;
    protected readonly String = String;
    private _isProcessing = false;
    formUpdateDebouncer: Subject<void> = new Subject<void>();
    private destroyed$ = new Subject<void>();
    select2DataFunction = (item) => item.text;
    activeTab:'requires' | 'ready';
    completionSummary: FulfillmentSummary = {
        stockLocationTotals: [],
        otherSourceTotals: {},
        fulfilledPartsCount: 0,
        notFulfilledPartsCount: 0,
        totalPartsCount: 0
    };
    isOrderFromSupplier: boolean = false;
    partsStockLocations: any;
    searchLocation: string = '';
    filteredStockRooms: any[] = [];
    isStockModule = false;

    ngOnInit() {
        this.onClose = new Subject();
        this.form = this.formBuilder.group({
            checkEngineerStockLocations: [this.selectedEngineerStockLocations, Validators.required],
            parts: this.formBuilder.array([])
        });
        this.getPartsAvailableStockLocations();
        this.initStockLocationSelect2();

        // Debounced form changes subscription
        this.formUpdateDebouncer
            .pipe(
                debounceTime(300),
                takeUntil(this.destroyed$)
            )
            .subscribe(() => {
                this.updateAllPartStatuses();
            });


        // Subscribe to form changes
        this.form.valueChanges
            .pipe(
                takeUntil(this.destroyed$)
            )
            .subscribe(() => {
                this.formUpdateDebouncer.next();
            });

        this.filteredStockRooms = [...this.fulfilFromStockRooms];
    }

    fulfil() {
        if(this.completionSummary.totalPartsCount == this.completionSummary.fulfilledPartsCount) {
            this.action = 'fulfilling';
            if (this.isOrderFromSupplier && this.moduleId != '1' ) {
                this.parts.forEach(p => delete p.name); // name not required , cause json parse error
                this.jobData.setPartLocations(this.partsStockLocations);
                this.jobData.setSelectedPart(this.parts);
                this.ajsState.transitionTo('loggedin.customer_list.view.job.details.new_job_part_purchase_order',{ id: this.customerId, jobId: this.jobId, type: this.customerType});
                this.bsModalRef.hide();
            } else {
                let data : any = {};
                data.selectedParts = JSON.stringify(this.parts);
                data.clientJobType = this.moduleId;
                data.jobToDos = this.jobToDos;
                data.jobId = this.jobId;
                data.milestoneId = 0;
                data.mergeJobPartIds = JSON.stringify([]);

                this.jobViewService.saveFulfilSelectedParts(data).subscribe(response=>{
                    this.action = '';
                    this.onClose.next(true);
                }, error => {
                    this.action = '';
                    console.log('err', error);
                });
            }
        }
    }

    ngAfterViewInit() {
        this.activeTab = 'requires';
        this.changeDetector.detectChanges();
        // Initialize select2 for each part's fulfil from other dropdown
        setTimeout(() => {
            this.partsFormArray.forEach((partGroup, index) => {
                this.initializeSelect2(partGroup, index);
            });

        });

        setTimeout(() => {
            this.saveBtn.nativeElement.focus();
        },900);
    }

    save() {
        if (this.form.invalid) { return; }

        this.action = 'saving';
    }

    toggleDropdown() {
        if (!this._isProcessing) {
            const selectedOptions = this.fulfilFromStockRooms.filter(option => option.selected);
            const unselectedOptions = this.fulfilFromStockRooms.filter(option => !option.selected);
            this.fulfilFromStockRooms = [...selectedOptions, ...unselectedOptions];

            this.filteredStockRooms = [...this.fulfilFromStockRooms];
            this.searchLocation = '';

            this.massUpdateDropdownOpen = !this.massUpdateDropdownOpen;
            this.changeDetector.detectChanges();
        }
    }

    selectStockLocationFromMassUpdate() {
        this.changeDetector.detach(); // Detach change detection during mass update
        this._isProcessing = true;
        try {
            this.fulfilFromOthers.forEach(opt => (opt.selected = false));
            const selectedSourceLabels = this.fulfilFromStockRooms.filter(opt => opt.selected).map(opt => opt.id);
            if (!selectedSourceLabels.length) return;
            const partsFormArray = this.form.get('parts') as FormArray;
            const batchSize = 20;
            const totalParts = partsFormArray.length;
            let processed = 0;
            let highlightIndices: number[] = [];
            const clearHighlight = (idx: number) => {
                if (this.parts[idx]._quantityModifiedTimer) {
                    clearTimeout(this.parts[idx]._quantityModifiedTimer);
                }
                this.parts[idx].quantityModified = true;
                this.parts[idx]._quantityModifiedTimer = setTimeout(() => {
                    this.parts[idx].quantityModified = false;
                    this.parts[idx]._quantityModifiedTimer = null;
                    this.changeDetector.detectChanges();
                }, 2000);
            };
            const processBatch = () => {
                const endIdx = Math.min(processed + batchSize, totalParts);
                highlightIndices = [];
                for (let i = processed; i < endIdx; i++) {
                    const partGroup = partsFormArray.at(i) as FormGroup;
                    if (this.parts[i].isFulfilled) continue;
                    const prevAllocations = this.parts[i].availableParts.map(loc => loc.allocation);
                    this.updatePartGroupForMassUpdate(partGroup, selectedSourceLabels);
                    const changed = this.parts[i].availableParts.some((loc, idx) => loc.allocation !== prevAllocations[idx]);
                    if (changed && !this.parts[i].hidden) {
                        clearHighlight(i);
                    }
                }
                processed = endIdx;
                this.changeDetector.detectChanges();
                if (processed < totalParts) {
                    setTimeout(processBatch, 0);
                } else {
                    this._isProcessing = false;
                    this.changeDetector.reattach();
                    this.changeDetector.detectChanges();
                    this.toggleDropdown(); // Only close dropdown after all batches processed
                    this.logFulfillmentStatus('massUpdate');
                }
            };
            processBatch();
        } catch (error) {
            console.error('Error in mass update:', error);
            this._isProcessing = false;
            this.changeDetector.reattach();
            this.changeDetector.detectChanges();
        }
    }

    selectFulfilFromOthers(selectedOption) {
        if (this._isProcessing) { return; }
        this._isProcessing = true;

        try {
            const isUncheck = selectedOption.selected;
            this.fulfilFromOthers.forEach(opt => (opt.selected = false));

            if (!isUncheck) {
                selectedOption.selected = true;
            }

            const partsFormArray = this.form.get('parts') as FormArray;
            this.changeDetector.detach();

            partsFormArray.controls.forEach((partGroup: FormGroup, index: number) => {
                if (this.parts[index].isFulfilled) {
                    return;
                }
                this.updatePartForFulfilFromOthers(partGroup, selectedOption, isUncheck);
            });

            this.changeDetector.reattach();
            this.changeDetector.detectChanges();
            this.toggleDropdown();
            this.formUpdateDebouncer.next();
        } finally {
            this._isProcessing = false;
            this.toggleDropdown();
        }
    }

    selectManualFulfilFromOthers(selectedOption, partGroup: FormGroup) {
        if (this._isProcessing) { return; }
        this._isProcessing = true;

        try {
            const remainingQty = this.calculateRemainingQuantity(partGroup);
            const partIndex = this.partsFormArray.indexOf(partGroup);
            // Centralized logic for orderToSupplier and General location
            this.handleOtherFulfillmentEffects(partGroup, selectedOption, remainingQty);

            // Then update the Select2 element from the form control's new value
            const currentOtherSelection = partGroup.get('selectFulfilFromOther').value;
            this.updateSelect2Element(partIndex, currentOtherSelection ? String(currentOtherSelection) : '', false);

            this.updatePartQuantityConstraints(partGroup);

            this.changeDetector.reattach();
            this.changeDetector.detectChanges();
            // this.toggleDropdown();
            this.formUpdateDebouncer.next();
        } finally {
            this._isProcessing = false;
        }
    }

    getSelectedLabel(): string {
        const selectedMulti = this.fulfilFromStockRooms
            .filter(opt => opt.selected)
            .map(opt => opt.label);
        return selectedMulti.length ? selectedMulti.join(', ') : '';
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        if (!this.massUpdateContainer) {
            return;
        }
        const container = this.massUpdateContainer.nativeElement as HTMLElement;
        if (!container.contains(event.target as Node) && this.massUpdateDropdownOpen) {
            this.toggleDropdown();
        }
    }

    createPartGroup(part): FormGroup {
        const remainingQty = part.totalQuantity; // Initial remaining quantity is the full part quantity
        const initialFulfilOptions = this.fulfilFromOthers.map(opt => ({
            ...opt,
            label: `${opt.label.split(' (')[0]} (${remainingQty})`
        }));

        return this.formBuilder.group({
            jobPartId: [part.jobPartId],
            partId: [part.partId],
            name: [part.name],
            code: [part.code],
            orderToSupplier: [part.orderToSupplier || 0],
            totalQuantity: [part.totalQuantity],
            selectFulfilFromOther: [part.selectFulfilFromOther],
            selectFulfilFromOtherQty: [part.selectFulfilFromOtherQty],
            hidden: [part.hidden],
            isFulfilled: [part.isFulfilled],
            availableParts: this.formBuilder.array(
                part.availableParts.map(loc => this.createLocationGroup(loc, part.partId))
            )
        }, {
            validators: [this.validatePartTotalQty()]
        });
    }

    createLocationGroup(loc, partId): FormGroup {
        const hasSufficientStock = loc.quantity > 0;
        const group = this.formBuilder.group({
            id: [loc.id],
            location: [loc.location],
            quantity: [loc.quantity],
            selected: [{
                value: loc.selected,
                disabled: !hasSufficientStock
            }],
            view: [loc.view],
            engineerName: [loc.engineerName],
            quantityInDue: [loc.quantityInDue],
            partId: [partId],
            allocation: [{
                value: loc.allocation || null,
                disabled: !loc.selected
            }, [
                Validators.min(0),
                Validators.pattern(/^\d*\.?\d{0,2}$/)
            ]]
        });

        // Handle selected checkbox changes
        group.get('selected').valueChanges.subscribe((checked) => {
            const qtyControl = group.get('allocation');
            const partGroup = group.parent.parent as FormGroup;
            const quantity = group.get('quantity').value; // Get the quantity
            const isSufficient = quantity > 0;
            if (checked && isSufficient) {
                qtyControl.enable();
                // Don't reset the value when enabling
                if (qtyControl.value === null) {
                    qtyControl.setValue('');
                }
            } else {
                qtyControl.setValue(null, { emitEvent: false });  // Set to null when unchecked
                qtyControl.disable();
            }

            // Check if part is fully fulfilled after selection change
            this.checkAndUpdateFulfilFromOtherState(partGroup);
        });

        // Handle quantity value changes
        group.get('allocation').valueChanges.subscribe((currentQtyInput) => {
            if (!group.get('selected').value) {
                return;
            }

            const partGroup = group.parent.parent as FormGroup;
            if (!partGroup) { return; }

            const totalRequired = partGroup.get('totalQuantity').value;
            const stockControl = group.get('quantity');
            const availableStock = stockControl.value;
            const partsArray = this.form.get('parts') as FormArray;
            const partIndex = partsArray.controls.indexOf(partGroup);
            const availableParts = partGroup.get('availableParts') as FormArray;
            const locationIndex = availableParts.controls.indexOf(group);
            const selectFulfilFromOtherControl = partGroup.get('selectFulfilFromOther');

            const isInputInvalid = isNaN(currentQtyInput) || currentQtyInput === null || currentQtyInput === '';

            if (isInputInvalid) {
                if (partIndex !== -1 && locationIndex !== -1) {
                    this.parts[partIndex].availableParts[locationIndex].allocation = 0;
                }
            } else {
                let adjustedQty = parseFloat(currentQtyInput);

                const otherLocationsQty = availableParts.controls
                    .filter(control => control !== group && control.get('selected').value === true)
                    .reduce((sum, control) => {
                        const allocation = parseFloat(control.get('allocation').value);
                        return sum + (isNaN(allocation) ? 0 : allocation);
                    }, 0);

                const remainingAllowed = Math.max(0, totalRequired - otherLocationsQty);
                const maxForThisInput = Math.min(availableStock, remainingAllowed);

                if (adjustedQty > maxForThisInput) {
                    adjustedQty = maxForThisInput;
                }
                if (adjustedQty < 0) {
                    adjustedQty = 0;
                }

                adjustedQty = parseFloat(adjustedQty.toFixed(2));

                if (group.get('allocation').value !== adjustedQty) {
                    group.get('allocation').setValue(adjustedQty, { emitEvent: false });
                }

                if (partIndex !== -1 && locationIndex !== -1) {
                    this.parts[partIndex].availableParts[locationIndex].allocation = adjustedQty;
                }
            }

            // Check fulfillment status and update UI accordingly
            const totalFulfilled = availableParts.controls
                .filter(loc => loc.get('selected').value)
                .reduce((sum, loc) => {
                    const allocation = parseFloat(loc.get('allocation').value);
                    return sum + (isNaN(allocation) ? 0 : allocation);
                }, 0);

            const isFulfilled = totalFulfilled >= totalRequired;

            if (this.parts[partIndex]) {
                this.parts[partIndex].isFulfilled = isFulfilled;
            }

            const select2Element = $(`#fulfil-from-other-${partIndex}`);
            if (isFulfilled) {
                if (selectFulfilFromOtherControl.enabled) {
                    selectFulfilFromOtherControl.disable({ emitEvent: false });
                    if (select2Element.length) {
                        select2Element.prop('disabled', true);
                    }
                }
            } else {
                if (selectFulfilFromOtherControl.disabled) {
                    selectFulfilFromOtherControl.enable({ emitEvent: false });
                    if (select2Element.length) {
                        select2Element.prop('disabled', false);
                    }
                }
            }
            this.changeDetector.detectChanges();
        });

        return group;
    }

    validatePartTotalQty() {
        return (group: FormGroup) => {
            const totalQuantity = group.get('totalQuantity').value;
            const stockLocs = group.get('availableParts') as any;
            const selectedQtySum = stockLocs.controls
                .filter(loc => loc.get('selected').value)
                .reduce((sum, loc) => sum + (+loc.get('allocation').value || 0), 0);
            return selectedQtySum > totalQuantity ? { exceedsPartQty: true } : null;
        };
    }

    getLocations(i: number) {
        return this.partsFormArray[i].get('availableParts')['controls'];
    }

    updateLocation() {
        if (!this._select2StockLocs) {
            return;
        }
        let selectedIds = $(this._select2StockLocs.nativeElement).val();
        if (typeof selectedIds === 'string') {
            selectedIds = selectedIds.split(',').map(id => Number(id.trim()));
        }

        // Ensure this.selectedEngineerStockLocations always holds the current user selection
        this.selectedEngineerStockLocations = Array.isArray(selectedIds) ? selectedIds : (selectedIds ? [selectedIds] : []);

        this.form.controls['checkEngineerStockLocations'].setValue(selectedIds && selectedIds.length > 0 ? selectedIds : null);

        // Update fulfilFromStockRooms based on the actual current selection
        if (this.selectedEngineerStockLocations && this.selectedEngineerStockLocations.length > 0) {
            const selectedLocations = this.engineerStocklocations.filter(location =>
                selectedIds.map(id => id.toString()).includes(location.id.toString())
            );
            this.fulfilFromStockRooms = selectedLocations.map(location => ({
                id: location.id,
                label: location.text,
                selected: false
            }));
        } else {
            this.fulfilFromStockRooms = [];
        }
        this.changeDetector.detectChanges();
    }

    getPartsAvailableStockLocations() {
        this.jobViewService.getPartsAvailableStockLocations(this.customerId, this.customerType, this.jobId, this.selectedPartsId).subscribe((data: any) => {
            this.engineerStocklocations = data['engineerStocklocations'];
            this.selectedEngineerStockLocations = data['engineerStocklocationIds'];
            this.isStockModule = data['isStockModule'];
            this.form.get('checkEngineerStockLocations').setValue(this.selectedEngineerStockLocations);
            this.fulfilFromStockRooms = this.engineerStocklocations.map(location => ({
                id: location.id,
                label: location.text,
                selected: false
            }));
            this.partsStockLocations = data['partsAvailableStocklocations'];
            const partsStockLocationsAvailable: any = data['partsAvailableStocklocations'];
            const partsFormated = Object.keys(this.selectedRows).map(id => {
                const partData = this.selectedRows[id];
                const partId = partData.partId;
                const locationData = partsStockLocationsAvailable.find(p => p.part_id === partId);
                // Check if location data is empty or has no stock
                const isOutOfStock = !locationData || !locationData.locations || locationData.locations.length === 0 ||
                    locationData.locations.every(loc => !(loc.view === true && loc.location !== 'General' && loc.quantity > 0));

                return {
                    jobPartId: id,
                    partId: partId,
                    name: partData.Part,
                    code: partData.MPN,
                    orderToSupplier: 0,
                    totalQuantity: parseFloat(partData.Quantity),
                    outOfStock: isOutOfStock,
                    fulfilFromOthers: this.fulfilFromOthers,
                    selectFulfilFromOther: '',
                    selectFulfilFromOtherQty: 0,
                    availableParts: (locationData.locations || [] ).map(loc => ({
                        id: loc.id,
                        location: loc.location,
                        quantity: loc.quantity || 0,
                        quantityInDue: loc.quantityInDue || 0,
                        engineerName: loc.engineerName,
                        allocation: 0,
                        selected: false,
                        view: loc.view
                    })),
                    hidden: false,
                    isFulfilled: false
                };
            });
            this.parts = partsFormated;
            const partsFormArray = this.form.get('parts') as FormArray;
            this.parts.forEach(part => {
                partsFormArray.push(this.createPartGroup(part));
            });
            this.isDataReady = true;
            this.changeDetector.detectChanges();
        }, (error: any) => {
            console.error('error', error);
        });
    }

    initStockLocationSelect2() {
        this.stockLocationsSelect2Config = {
            multiple: true,
            query: (query) => {
                if (query.term) {
                    this.jobViewService.getAllStockLocations(query.term).subscribe((response: any) => {
                        const newLocations = response && Array.isArray(response) ? response.filter(item => item && typeof item === 'object' && item.id !== undefined) : [];
                        const allCurrentAndNewLocations = this.engineerStocklocations.concat(newLocations);
                        this.engineerStocklocations = Array.from(new Map(allCurrentAndNewLocations.map(item => [item.id, item] as [any, any])).values());
                        const filteredResults = this.engineerStocklocations.filter(loc =>
                            loc.text.toLowerCase().includes(query.term.toLowerCase())
                        );
                        query.callback({ results: filteredResults });
                    });
                } else {
                    query.callback({ results: this.engineerStocklocations });
                }
            },
            initSelection: (element, callback) => {
                const data = [];
                const selectedIds = this.selectedEngineerStockLocations;
                const allLocations = this.engineerStocklocations;

                for (const id of selectedIds) {
                    const location = allLocations.find(loc => loc.id.toString() === id.toString());
                    if (location) {
                        data.push(location);
                    }
                }
                callback(data);
            }
        };
    }

    updateLocationViewStatus() {
        // Ensure selectedLocationIds is an array, even if null/undefined initially from select2
        const selectedLocationIds = this.form.get('checkEngineerStockLocations').value || [];
        const partsFormArray = this.form.get('parts') as FormArray;

        partsFormArray.controls.forEach((partGroup: FormGroup, partIndex: number) => {
            const stockLocationsFormArray = partGroup.get('availableParts') as FormArray;
            let hasVisibleAndStockedLocations = false;

            stockLocationsFormArray.controls.forEach((locGroup: FormGroup, locationIndex: number) => {
                const locationIdInForm = locGroup.get('id').value;

                // Crucially, ensure both sides of includes() are consistent types (strings)
                // The select2 value for multi-select is usually an array of strings.
                const isLocationSelectedInDropdown = selectedLocationIds
                    .map(id => id.toString())
                    .includes(locationIdInForm.toString());

                // Set the 'view' control value
                locGroup.get('view').setValue(isLocationSelectedInDropdown);

                // If the location is NOT selected in the main dropdown,
                // it should be unselected and its quantity reset in the part's form group.
                if (!isLocationSelectedInDropdown) {
                    if (locGroup.get('selected').value === true) { // Only change if it was previously selected
                        locGroup.get('selected').setValue(false, { emitEvent: false });
                        locGroup.get('allocation').setValue(0, { emitEvent: false });
                        locGroup.get('allocation').disable({ emitEvent: false });
                        // Update the component's internal data model for consistency
                        if (this.parts[partIndex] && this.parts[partIndex].availableParts[locationIndex]) {
                            this.parts[partIndex].availableParts[locationIndex].selected = false;
                            this.parts[partIndex].availableParts[locationIndex].allocation = 0;
                        }
                    }
                } else {
                    //If it IS selected in the main dropdown, ensure its allocation control is ENABLED
                    // if its 'selected' checkbox within the part is true. This handles re-enabling.
                    if (locGroup.get('selected').value === true && locGroup.get('allocation').disabled) {
                        locGroup.get('allocation').enable({ emitEvent: false });
                    }
                }

                // Re-evaluate hasVisibleAndStockedLocations for this part
                // Only consider locations that are viewable, not 'General', and have stock.
                //Check locGroup.get('view').value directly AFTER setValue
                if (locGroup.get('view').value === true && locGroup.get('location').value !== 'General' && locGroup.get('quantity').value > 0) {
                    hasVisibleAndStockedLocations = true;
                }
            });

            // Update the part's outOfStock status based on whether any visible, stocked locations exist
            // This is the source of truth for the 'out of stock' message.
            if (this.parts[partIndex]) {
                this.parts[partIndex].outOfStock = !hasVisibleAndStockedLocations;
            }
            this.updatePartState(partGroup, partIndex);
        });
        this.changeDetector.detectChanges();
        this.formUpdateDebouncer.next();
    }

    updatePartQuantityConstraints(partGroup: FormGroup) {
        if (!partGroup) {
            return;
        }

        const partIndex = this.partsFormArray.findIndex(p => p === partGroup);
        if (partIndex === -1) {
            return;
        }

        // Update fulfillment status
        this.updatePartState(partGroup, partIndex);

        // Trigger debounced update instead of direct call
        this.formUpdateDebouncer.next();

        // Update form validation
        partGroup.updateValueAndValidity({ emitEvent: true });
        this.changeDetector.detectChanges();
    }

    getRemainingQty(partGroup: FormGroup): number {
        if (!partGroup) { return 0; }

        const totalQty = partGroup.get('totalQuantity').value;
        const availableParts = partGroup.get('availableParts') as FormArray;

        const fulfilledQty = availableParts.controls
            .filter(loc => loc.get('selected').value)
            .reduce((sum, loc) => sum + (+loc.get('allocation').value || 0), 0);

        return Math.max(0, totalQty - fulfilledQty);
    }

    ngOnDestroy() {
        this.changeDetector.detach();
        // Cleanup select2 instances for main dropdown on destroy
        if (this._select2StockLocs && $(this._select2StockLocs.nativeElement).data('select2')) {
            $(this._select2StockLocs.nativeElement).select2('destroy');
        }

        // Cleanup select2 instances
        this.partsFormArray.forEach((_, index) => {
            $(`#fulfil-from-other-${index}`).select2('destroy');
        });
        this.destroyed$.next();
        this.destroyed$.complete();
        this.formUpdateDebouncer.complete();
    }

    calculateRemainingQuantity(partGroup: FormGroup): number {
        const totalQty = partGroup.get('totalQuantity').value;
        const availableParts = partGroup.get('availableParts') as FormArray;

        const fulfilledQty = availableParts.controls
            .filter(loc => loc.get('selected').value)
            .reduce((sum, loc) => sum + (+loc.get('allocation').value || 0), 0);

        return Math.max(0, totalQty - fulfilledQty);
    }

    updateSelect2Element(index: number, value: string | null = null, disabled: boolean = false) {
        const select2Element = $(`#fulfil-from-other-${index}`);
        select2Element.prop('disabled', disabled);
        if (value !== null) {
            select2Element.val(value).trigger('change');
        }
    }

    updateLocationControls(locGroup: FormGroup, selected: boolean, allocation: any = '') {
        const qtyControl = locGroup.get('allocation');
        const selectedControl = locGroup.get('selected');

        selectedControl.setValue(selected, { emitEvent: false });
        qtyControl[selected ? 'enable' : 'disable']({ emitEvent: false });
        qtyControl.setValue(allocation, { emitEvent: false });
        // locGroup.get('view').setValue(true);
    }

    updatePartGroupForMassUpdate(partGroup: FormGroup, selectedSourceLabels: number[]) {
        const partIndex = this.partsFormArray.indexOf(partGroup);
        const remainingQtyToDistribute = partGroup.get('totalQuantity').value;
        const availableParts = partGroup.get('availableParts') as FormArray;

        // Store current quantities before reset
        const currentQtys = new Map();
        availableParts.controls.forEach(loc => {
            if (loc.get('selected').value && loc.get('allocation').value !== null) {
                currentQtys.set(loc.get('id').value, loc.get('allocation').value);
            }
        });

        // Reset form control values
        this.resetPartGroupControls(partGroup);

        this.updateLocationsForMassUpdate(availableParts, selectedSourceLabels, remainingQtyToDistribute, currentQtys);

        // Handle remaining quantity and select2 updates
        this.handleRemainingQuantity(partGroup, partIndex);
    }

    resetPartGroupControls(partGroup: FormGroup) {
        partGroup.patchValue({
            selectFulfilFromOther: '',
            selectFulfilFromOtherQty: 0,
            orderToSupplier: 0
        }, { emitEvent: false });
    }

    updateLocationsForMassUpdate(locationsArray: FormArray, selectedIds: number[], remainingQty: number, currentQtys: Map<number, number>) {
        const partGroup = locationsArray.parent as FormGroup;
        const partIndex = this.partsFormArray.indexOf(partGroup);
        const partRequiredQty = partGroup.get('totalQuantity').value;
        const select2Element = $(`#fulfil-from-other-${partIndex}`);

        // Combine resets into a single loop for better performance
        const controls = locationsArray.controls;
        const partAvailableParts = partIndex !== -1 ? this.parts[partIndex].availableParts : null;

        for (let i = 0; i < controls.length; i++) {
            const locGroup = controls[i] as FormGroup;
            // Reset form controls
            this.updateLocationControls(locGroup, false, '');

            // Reset data model if available
            if (partAvailableParts && partAvailableParts[i]) {
                partAvailableParts[i].allocation = 0;
                partAvailableParts[i].selected = false;
            }
        }

        // Distribute quantities among newly selected or previously partially/fully fulfilled locations
        let quantityToDistribute = partRequiredQty;

        // First, prioritize re-applying quantities to locations that were previously fulfilling the part
        locationsArray.controls.forEach((locGroup: FormGroup, locationIndex: number) => {
            const id = locGroup.get('id').value;
            const isNewlySelected = selectedIds.includes(id);
            const availableStockQty = locGroup.get('quantity').value;
            const hasStock = availableStockQty !== null && availableStockQty > 0;

            const isAlreadyHandled = locGroup.get('selected').value && locGroup.get('allocation').value > 0;

            if (isNewlySelected && hasStock && !isAlreadyHandled && quantityToDistribute > 0) {
                const availableStock = locGroup.get('quantity').value;
                const qtyToTake = Math.min(quantityToDistribute, availableStock);

                this.updateLocationControls(locGroup, true, qtyToTake);
                quantityToDistribute -= qtyToTake;

                if (partIndex !== -1 && this.parts[partIndex].availableParts[locationIndex]) {
                    this.parts[partIndex].availableParts[locationIndex].allocation = qtyToTake;
                    this.parts[partIndex].availableParts[locationIndex].selected = true;
                }
            }
        });

        // Then, distribute remaining quantity among newly selected locations (if any remaining)
        locationsArray.controls.forEach((locGroup: FormGroup, locationIndex: number) => {
            const id = locGroup.get('id').value;
            const isNewlySelected = selectedIds.includes(id);
            const isAlreadyHandled = locGroup.get('selected').value && locGroup.get('allocation').value > 0;
            const availableStockQty = locGroup.get('quantity').value;
            const hasStock = availableStockQty !== null && availableStockQty > 0;

            if (isNewlySelected && hasStock && !isAlreadyHandled && quantityToDistribute > 0) {
                const availableStock = locGroup.get('quantity').value;
                const qtyToTake = Math.min(quantityToDistribute, availableStock);

                this.updateLocationControls(locGroup, true, qtyToTake);
                quantityToDistribute -= qtyToTake;

                // Update parts array data model
                if (partIndex !== -1 && this.parts[partIndex].availableParts[locationIndex]) {
                    this.parts[partIndex].availableParts[locationIndex].allocation = qtyToTake;
                    this.parts[partIndex].availableParts[locationIndex].selected = true;
                }
            }
        });

        // If there's still a remaining quantity after distributing from stock, update the "fulfil from other" section
        const selectedOptionFromMassUpdate = this.fulfilFromOthers.find(opt => opt.selected);
        const currentOtherSelectionInForm = partGroup.get('selectFulfilFromOther').value;
        if (remainingQty > 0) {
            if (selectedOptionFromMassUpdate) {
                // If a mass update option for 'other' is chosen, apply it
                partGroup.patchValue({
                    selectFulfilFromOther: selectedOptionFromMassUpdate.id,
                    selectFulfilFromOtherQty: remainingQty
                }, { emitEvent: false });
                this.updateSelect2Element(partIndex, String(selectedOptionFromMassUpdate.id));
                this.handleOtherFulfillmentEffects(partGroup, selectedOptionFromMassUpdate.id, remainingQty);
            } else if (currentOtherSelectionInForm) {
                // If there's an existing 'other' selection and no new mass update for 'other',
                // just update its quantity and re-apply its effects with the new quantity.
                partGroup.patchValue({
                    selectFulfilFromOtherQty: remainingQty // Only update quantity
                }, { emitEvent: false });
                this.updateSelect2Element(partIndex, String(currentOtherSelectionInForm)); // Keep visual
                this.handleOtherFulfillmentEffects(partGroup, currentOtherSelectionInForm, remainingQty);
            } else {
                // No mass update 'other' selected, no previous 'other' selection, and still remaining qty
                // Keep the fields clear, but enable the select2.
                partGroup.patchValue({
                    selectFulfilFromOther: '', // Explicitly clear in form if nothing was selected
                    selectFulfilFromOtherQty: 0
                }, { emitEvent: false });
                this.updateSelect2Element(partIndex, '');
                this.handleOtherFulfillmentEffects(partGroup, null, 0); // Ensure effects are cleared
            }
        } else {
            select2Element.prop('disabled', true); // Disable the control
        }

        // Re-enable select2 if no stock locations are selected and not fully fulfilled
        // This condition should now correctly enable the select2 if remainingQty > 0.
        if (remainingQty > 0) { // Removed hasSelectedStockLocations check, remainingQty is sufficient
            this.updateSelect2Element(partIndex, null, false); // Enable select2
        }
        partGroup.updateValueAndValidity();
    }

    handleRemainingQuantity(partGroup: FormGroup, partIndex: number) {
        const availableParts = partGroup.get('availableParts') as FormArray;

        // Calculate fulfilled and remaining quantities
        const fulfilledQty = availableParts.controls
            .filter(loc => loc.get('selected').value)
            .reduce((sum, loc) => sum + (+loc.get('allocation').value || 0), 0);

        const remainingQty = Math.max(0, partGroup.get('totalQuantity').value - fulfilledQty);

        // Get select2 element
        const select2Element = $(`#fulfil-from-other-${partIndex}`);
        const currentOtherSelectionInForm = partGroup.get('selectFulfilFromOther').value;

        if (remainingQty > 0) {
            // Enable select2 if there's remaining quantity
            select2Element.prop('disabled', false);

            // Apply mass update option if selected
            const selectedOption = this.fulfilFromOthers.find(opt => opt.selected);
            if (selectedOption) {
                partGroup.patchValue({
                    selectFulfilFromOther: selectedOption.id,
                    selectFulfilFromOtherQty: remainingQty
                }, { emitEvent: false });
                // select2Element.val(selectedOption.id.toString()).trigger('change');
                this.updateSelect2Element(partIndex, String(selectedOption.id));
                // Trigger effects for "other" fulfillment
                this.handleOtherFulfillmentEffects(partGroup, selectedOption.id, remainingQty);
            } else if (currentOtherSelectionInForm) {
                // If there's an existing 'other' selection and no new mass update for 'other',
                // just update its quantity and re-apply its effects with the new quantity.
                partGroup.patchValue({
                    selectFulfilFromOtherQty: remainingQty
                }, { emitEvent: false });
                this.updateSelect2Element(partIndex, String(currentOtherSelectionInForm)); // Keep visual
                this.handleOtherFulfillmentEffects(partGroup, currentOtherSelectionInForm, remainingQty);
            } else {
                partGroup.patchValue({
                    selectFulfilFromOther: '',
                    selectFulfilFromOtherQty: 0
                }, { emitEvent: false });
                this.updateSelect2Element(partIndex, '');
                // If no mass update option, ensure other effects are cleared if they were applied
                this.handleOtherFulfillmentEffects(partGroup, null, 0);
            }
        } else {
            select2Element.prop('disabled', true);
        }

        // Update form validation
        partGroup.updateValueAndValidity();
        this.updatePartQuantityConstraints(partGroup);
    }

    updatePartForFulfilFromOthers(partGroup: FormGroup, selectedOption: any, isUncheck: boolean) {
        const remainingQty = this.calculateRemainingQuantity(partGroup);
        const partIndex = this.partsFormArray.indexOf(partGroup);

        if (!isUncheck && remainingQty > 0) {
            partGroup.patchValue({
                selectFulfilFromOther: selectedOption.id,
                selectFulfilFromOtherQty: remainingQty
            }, { emitEvent: false });

            this.updateSelect2Element(partIndex, selectedOption.id.toString());
            // Trigger effects for "other" fulfillment
            this.handleOtherFulfillmentEffects(partGroup, selectedOption.id, remainingQty);
        } else {
            partGroup.patchValue({
                selectFulfilFromOther: '',
                selectFulfilFromOtherQty: 0
            }, { emitEvent: false });

            this.updateSelect2Element(partIndex, '');
            // Clear effects for "other" fulfillment
            this.handleOtherFulfillmentEffects(partGroup, null, 0);
        }
        this.updatePartQuantityConstraints(partGroup);
    }

    logFulfillmentStatus(action: string) {
        const summary = this.calculateFulfillmentSummary();
        console.log(`[${action}] Fulfillment Status:`, summary);
        console.log('form parts', this.form.get('parts').value);
        console.log('parts', this.parts);
        return summary;
    }

    calculateFulfillmentSummary(): FulfillmentSummary {
        const summary: FulfillmentSummary = {
            stockLocationTotals: [],
            otherSourceTotals: {
                'job.purchase.order': 0,
                'job.leave.remaining': 0,
                'job.general': 0
            },
            fulfilledPartsCount: 0,
            notFulfilledPartsCount: 0,
            totalPartsCount: 0
        };

        const partsFormArray = this.form.get('parts') as FormArray;

        partsFormArray.controls.forEach((partGroup: FormGroup, partIndex: number) => {
            summary.totalPartsCount++;
            const currentPartInPartsArray = this.parts[partIndex];

            // Calculate stock location quantities
            const availableParts = partGroup.get('availableParts') as FormArray;
            availableParts.controls.forEach((locGroup: FormGroup, locationIndex: number) => {
                //
                if (locGroup.get('view').value && !this.parts[partIndex].availableParts[locationIndex].view){
                    currentPartInPartsArray.availableParts[locationIndex].view = locGroup.get('view').value;
                }
                if (locGroup.get('selected').value) {
                    const id = locGroup.get('id').value;
                    const location = locGroup.get('location').value;
                    const allocation = +locGroup.get('allocation').value || 0;

                    currentPartInPartsArray.availableParts[locationIndex].selected = locGroup.get('selected').value;

                    if (allocation > 0) {
                        const existingLocation = summary.stockLocationTotals.find(
                            loc => loc.id === id
                        );

                        if (existingLocation) {
                            existingLocation.totalQty += allocation;
                        } else {
                            summary.stockLocationTotals.push({
                                id: id,
                                location: location,
                                totalQty: allocation
                            });
                        }
                    }
                }
            });

            // Calculate other source quantities using the mapping
            const fulfilFromOtherValue = partGroup.get('selectFulfilFromOther').value;
            const selectFulfilFromOtherQty = partGroup.get('selectFulfilFromOtherQty').value; // Get actual quantity from form
            if (fulfilFromOtherValue && selectFulfilFromOtherQty > 0) {
                const sourceKey = this.fulfilFromOtherMapping[fulfilFromOtherValue];
                if (sourceKey && fulfilFromOtherValue !== 3 && fulfilFromOtherValue !== 3) {
                    summary.otherSourceTotals[sourceKey] += selectFulfilFromOtherQty;
                }
            }

            // Update fulfilled status based on total quantities
            const totalQty = partGroup.get('totalQuantity').value;
            const stockLocationQty = availableParts.controls
                .filter(loc => loc.get('selected').value)
                .reduce((sum, loc) => sum + (+loc.get('allocation').value || 0), 0);
            const currentOtherFulfilQty = partGroup.get('selectFulfilFromOtherQty').value || 0;
            const isFulfilled = (stockLocationQty + currentOtherFulfilQty) >= totalQty;
            // Ensure isFulfilled in the internal parts array is updated
            if (currentPartInPartsArray) {
                currentPartInPartsArray.isFulfilled = isFulfilled;
            }

            if (isFulfilled) {
                summary.fulfilledPartsCount++;
            } else {
                summary.notFulfilledPartsCount++;
            }
        });
        this.completionSummary = summary;
        this.isOrderFromSupplier = this.parts.some(part => part.orderToSupplier && part.orderToSupplier > 0);
        this.changeDetector.detectChanges();
        return summary;
    }

    onFulfilFromOtherChange(selectedValue: string | null, partGroup: FormGroup, index: number) {
        const totalRequired = partGroup.get('totalQuantity').value;
        const stockLocationQty = this.calculateStockLocationQty(partGroup);
        const remainingQty = Math.max(0, totalRequired - stockLocationQty);

        const select2Element = $(`#fulfil-from-other-${index}`);
        if (select2Element.length) {
            select2Element.val(selectedValue).trigger('change');
        }

        this.handleOtherFulfillmentEffects(partGroup, selectedValue, selectedValue ? remainingQty : 0);

        const status = this.updatePartState(partGroup, index);

        this.changeDetector.detectChanges();

        this.formUpdateDebouncer.next();
        this.logFulfillmentStatus(`Fulfillment status updated: ${status.totalFulfilled}/${partGroup.get('totalQuantity').value}`);
    }

    calculateStockLocationQty(partGroup: FormGroup): number {
        const availableParts = partGroup.get('availableParts') as FormArray;
        return availableParts.controls
            .filter(loc => loc.get('selected').value)
            .reduce((sum, loc) => sum + (+loc.get('allocation').value || 0), 0);
    }

    updateAllPartStatuses() {
        this.partsFormArray.forEach((partGroup, index) => {
            const totalRequired = partGroup.get('totalQuantity').value;
            const stockLocationQty = this.calculateStockLocationQty(partGroup);
            const fulfilFromOther = partGroup.get('selectFulfilFromOther').value;
            const remainingQty = Math.max(0, totalRequired - stockLocationQty);

            this.parts[index].isFulfilled = fulfilFromOther ?
                (stockLocationQty + remainingQty) >= totalRequired :
                stockLocationQty >= totalRequired;

            this.parts[index].hidden = this.parts[index].isFulfilled;
            this.changeDetector.detectChanges();
        });

        this.changeDetector.detectChanges();
        this.updateSummary();
    }

    updateSummary() {
        const totalParts = this.parts.length;
        const fulfilledParts = this.parts.filter(p => p.isFulfilled).length;
        // Update your summary display logic here
        this.logFulfillmentStatus(`Parts fulfilled: ${fulfilledParts}/${totalParts}`);
    }

    getOptionTemplate(index: number) {
        return (data: any) => {
            if (!data.id) { return data.text; }
            const option = this.fulfilFromOthers.find(opt => opt.id === +data.id);
            if (option) {
                const remainingQty = this.getRemainingQty(this.partsFormArray[index]);
                return `${option.label} (${remainingQty})`;
            }
            return data.text;
        };
    }

    calculateFulfillmentStatus(partGroup: FormGroup): FulfillmentStatus {
        const totalRequired = partGroup.get('totalQuantity').value;
        const stockLocationQty = this.calculateStockLocationQty(partGroup);
        const fulfilFromOtherValue = partGroup.get('selectFulfilFromOther').value;
        const remainingQty = Math.max(0, totalRequired - stockLocationQty);
        const fromOtherQty = fulfilFromOtherValue ? remainingQty : 0;
        const totalFulfilled = stockLocationQty + fromOtherQty;

        return {
            isFulfilled: totalFulfilled >= totalRequired,
            totalFulfilled,
            fromStock: stockLocationQty,
            fromOther: fromOtherQty
        };
    }

    updatePartState(partGroup: FormGroup, index: number) {
        const status = this.calculateFulfillmentStatus(partGroup);
        const select2Element = $(`#fulfil-from-other-${index}`);

        // Update part status
        this.parts[index].isFulfilled = status.isFulfilled;

        // Update UI visibility
        setTimeout(()=>{
            this.parts[index].hidden = status.isFulfilled;
        });

        // Update select2 state
        if (status.fromStock >= partGroup.get('totalQuantity').value) {
            select2Element.prop('disabled', true);
        } else {
            select2Element.prop('disabled', false);
        }
        this.changeDetector.detectChanges();
        return status;
    }

    initializeSelect2(partGroup: FormGroup, index: number) {
        const select2Element = $(`#fulfil-from-other-${index}`);

        select2Element.select2({
            width: '100%',
            minimumResultsForSearch: Infinity,
            placeholder: '-- Select fulfil option --',
            allowClear: true,
            templateResult: this.getOptionTemplate(index),
            templateSelection: this.getOptionTemplate(index)
        }).on('select2:select select2:clear', (e: any) => {
            const selectedValue = e.type === 'select2:clear' ? '' : e.params.data.id;
            this.onFulfilFromOtherChange(selectedValue, partGroup, index);
        });

        // Set initial value for select2 from the form control.
        // This is crucial for when the modal opens or tab switches.
        const currentSelectedOther = partGroup.get('selectFulfilFromOther').value;
        this.updateSelect2Element(index, currentSelectedOther ? String(currentSelectedOther) : '', false);

        // Initial state update
        this.updatePartState(partGroup, index);
    }

    checkAndUpdateFulfilFromOtherState(partGroup: FormGroup) {
        if (!partGroup) return;

        const totalRequired = partGroup.get('totalQuantity').value;
        const availableParts = partGroup.get('availableParts') as FormArray;
        const partsArray = this.form.get('parts') as FormArray;
        const partIndex = partsArray.controls.indexOf(partGroup);

        // Calculate total fulfilled from stock locations
        const totalFulfilled = availableParts.controls
            .filter(control => control.get('selected').value)
            .reduce((sum, control) => {
                const allocation = control.get('allocation').value;
                return sum + ((!isNaN(allocation) && allocation !== null) ? parseFloat(allocation) : 0);
            }, 0);

        // Get the select2 element
        const select2Element = $(`#fulfil-from-other-${partIndex}`);

        // Disable/enable based on fulfillment status
        if (totalFulfilled >= totalRequired) {
            select2Element.prop('disabled', true);
        } else {
            select2Element.prop('disabled', false);
        }
    }

    resetPartFulfillment(index: number, partItem) {
        if (index < 0 || index >= this.partsFormArray.length) {
            console.warn(`Attempted to reset part at invalid index: ${index}`);
            return;
        }

        const partGroup = this.partsFormArray[index] as FormGroup;
        const availableParts = partGroup.get('availableParts') as FormArray;

        // 1. Reset all stock location selections and quantities for this part
        availableParts.controls.forEach((locGroup: FormGroup, locationIndex: number) => {
            locGroup.patchValue({
                selected: false,
                allocation: ''
            }, { emitEvent: false });
            locGroup.get('allocation').disable({ emitEvent: false });
            partItem.availableParts[locationIndex].selected = false;
            partItem.availableParts[locationIndex].allocation = '';
        });

        // Get a reference to the selectFulfilFromOther form control
        const fulfilFromOtherControl = partGroup.get('selectFulfilFromOther');

        // Enable the form control and reset its value
        if (fulfilFromOtherControl.disabled) {
            fulfilFromOtherControl.enable({ emitEvent: false });
        }
        fulfilFromOtherControl.setValue('', { emitEvent: false });

        // Update its isFulfilled and hidden status to 'not fulfilled'
        // This will also re-enable the Select2 dropdown via updatePartState
        this.parts[index].isFulfilled = false;
        this.parts[index].hidden = false;

        // Re-enable its associated Select2 dropdown and clear its value
        this.updateSelect2Element(index, '', false); // Clear value and enable

        this.handleOtherFulfillmentEffects(partGroup, null, 0);

        // Recalculate and update the state of this specific part
        this.updatePartState(partGroup, index);

        // Update validity of the part group and trigger debounced form update
        partGroup.updateValueAndValidity({ emitEvent: true });
        this.formUpdateDebouncer.next();
        this.changeDetector.detectChanges();
        this.logFulfillmentStatus(`Part at index ${index} reset.`);
    }

    selectTab(tab: 'requires' | 'ready') {
        this.activeTab = tab;
        this.changeDetector.detectChanges();

        // When switching back to 'requires', ensure Select2 is correctly initialized and its value set
        if (this.activeTab === 'requires') {
            // Use setTimeout to allow DOM rendering to complete, then re-initialize/set Select2
            setTimeout(() => {
                if (!$(this._select2StockLocs.nativeElement).data('select2')) {
                    this.initAndAttachMainSelect2();
                }
            }, 0);
        }
    }

    initAndAttachMainSelect2() {
        if (this._select2StockLocs && this._select2StockLocs.nativeElement) {
            // Destroy any existing Select2 instance to prevent re-initialization issues
            if ($(this._select2StockLocs.nativeElement).data('select2')) {
                $(this._select2StockLocs.nativeElement).select2('destroy');
            }

            // Initialize Select2 with its config
            $(this._select2StockLocs.nativeElement).select2(this.stockLocationsSelect2Config); // Use the existing config

            // Set the value immediately after initialization
            $(this._select2StockLocs.nativeElement).val(this.selectedEngineerStockLocations).trigger('change');

            // Attach the change listener
            $(this._select2StockLocs.nativeElement).on('change', () => {
                this.updateLocation(); // This updates this.selectedEngineerStockLocations and the form control
                this.updateLocationViewStatus(); //
            });
        }
    }

    handleOtherFulfillmentEffects(partGroup: FormGroup, selectedFulfilOptionId: any | null, quantity: number) {
        const partIndex = this.partsFormArray.indexOf(partGroup);
        if (partIndex === -1) {
            return;
        }
        const currentPartInPartsArray = this.parts[partIndex]; // Reference to the part in this.parts array
        const availablePartsFormArray = partGroup.get('availableParts') as FormArray;
        const numericSelectedFulfilOptionId = typeof selectedFulfilOptionId === 'string' ? parseFloat(selectedFulfilOptionId) : selectedFulfilOptionId;

        partGroup.get('selectFulfilFromOther').setValue(selectedFulfilOptionId || '', { emitEvent: false });
        partGroup.get('selectFulfilFromOtherQty').setValue(quantity, { emitEvent: false });

        currentPartInPartsArray.selectFulfilFromOther = selectedFulfilOptionId;
        currentPartInPartsArray.selectFulfilFromOtherQty = quantity;

        // Reset orderToSupplier for this part
        currentPartInPartsArray.orderToSupplier = 0;
        partGroup.get('orderToSupplier').setValue(0, { emitEvent: false });

        // Reset General location allocation for this part (both form and internal model)
        const generalLocationGroup = availablePartsFormArray.controls.find(loc => loc.get('location').value === 'General');
        if (generalLocationGroup) {
            generalLocationGroup.get('allocation').setValue(0, { emitEvent: false }); // Reset quantity in form
            generalLocationGroup.get('selected').setValue(false, { emitEvent: false }); // Unselect in form
            generalLocationGroup.get('allocation').disable({ emitEvent: false }); // Disable input in form

            // Update internal data model for 'General' location
            const generalLocationInPartsArray = currentPartInPartsArray.availableParts.find(loc => loc.location === 'General');
            if (generalLocationInPartsArray) {
                generalLocationInPartsArray.allocation = 0;
                generalLocationInPartsArray.selected = false;
            }
        }

        // Apply new effects based on selected option
        if (numericSelectedFulfilOptionId === 1) { // 'Order remaining from supplier'
            currentPartInPartsArray.orderToSupplier = quantity;
            partGroup.get('orderToSupplier').setValue(quantity, { emitEvent: false });
        } else if (numericSelectedFulfilOptionId === 3) { // 'Fulfil from general'
            if (generalLocationGroup) {
                generalLocationGroup.get('allocation').setValue(quantity, { emitEvent: false });
                generalLocationGroup.get('selected').setValue(true, { emitEvent: false });
                generalLocationGroup.get('allocation').enable({ emitEvent: false });

                // Update internal data model for 'General' location
                const generalLocationInPartsArray = currentPartInPartsArray.availableParts.find(loc => loc.location === 'General');
                if (generalLocationInPartsArray) {
                    generalLocationInPartsArray.allocation = quantity;
                    generalLocationInPartsArray.selected = true;
                }
            }
        }
        this.changeDetector.detectChanges();
    }

    onCloseModal() {
        this.bsModalRef.hide();
        this.onClose.next('close');
    }

    filterStockRooms(filterText: string) {
        if (!filterText) {
            this.filteredStockRooms = [...this.fulfilFromStockRooms];
        } else {
            this.filteredStockRooms = this.fulfilFromStockRooms.filter(option =>
                option.label.toLowerCase().includes(filterText.toLowerCase())
            );
        }
    }

    partTrackBy(index: number, part: any): string {
        return part.jobPartId;
    }

    locationTrackBy(index: number, location: any): string {
        return location.get('id').value;
    }
}
